import React from 'react';
import styled from 'styled-components';

import { Slider } from '../Slider';
import { breakpoints } from '../../constants';

interface IProps {
    className?: string;
}

const Row = styled.div`
    @media (${breakpoints.mediumMin}) {
        display: flex;
        flex-direction: row-reverse;
        align-items: center;
    }

    h2 {
        font-size: 34px;
        font-weight: 500;
    }

    ul {
        padding: 0;
        list-style-position: inside;
    }

    li,
    p {
        font-size: 0.9rem;
    }

    a {
        color: #ef8200;
    }
`;

const LeftColumn = styled.div`
    @media (${breakpoints.mediumMin}) {
        flex: 0 0 40%;
    }
`;

const RightColumn = styled.div`
    @media (${breakpoints.mediumMin}) {
        flex: 0 0 60%;
    }
`;

const BaseAppView: React.FC<IProps> = ({ className }) => (
    <div className={className}>
        <Row>
            <RightColumn>
                <h2>De voordelen van een gepolariseerde zonnebril</h2>
                <ul>
                    <li>Perfect zicht op je omgeving</li>
                    <li>Bescherm je ogen tegen soms pijnlijke zonnestralen</li>
                    <li>
                        Zeer geschikt voor het autorijden en de water- en
                        wintersport
                    </li>
                    <li>
                        Geef je ogen rust (minder knijpen = minder rimpels!)
                    </li>
                </ul>
                <p>
                    Meer weten? Dit is wat je moet weten{' '}
                    <a
                        href="https://blog.pearle.nl/gepolariseerde-zonnebril-alles-wat-jij-moet-weten/"
                        target="_parent"
                    >
                        over gepolariseerde zonnebrillen
                    </a>
                </p>
            </RightColumn>
            <LeftColumn>
                <img
                    alt="gepolariseerde zonnebril"
                    src="https://grandvision.s3.amazonaws.com/pnl/images/gepolariseerde-zb.png"
                />
            </LeftColumn>
        </Row>
        <Slider />
    </div>
);

export const AppView = styled(BaseAppView)`
    max-width: 1370px;
    margin: 0 auto;
    background-color: #f5f5f5;
    padding: 40px;
`;
